import { Invoice } from './types';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function formatCurrency(n: number) {
  return `$${n.toFixed(2)}`;
}

export async function exportInvoicePDF(inv: Invoice) {
  // create temporary container with styled HTML for the invoice
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.left = '-9999px';
  container.style.top = '0';
  container.style.background = 'white';
  container.style.padding = '24px';
  container.style.width = '800px';
  container.style.fontFamily = 'Arial, Helvetica, sans-serif';

  const itemsHtml = inv.items.map(it => `
    <tr>
      <td style="padding:8px;border-bottom:1px solid #eee">${it.description}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right">${it.qty}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right">${formatCurrency(it.price)}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right">${formatCurrency(it.qty * it.price)}</td>
    </tr>
  `).join('');

  const total = inv.items.reduce((s, it) => s + it.qty * it.price, 0);

  container.innerHTML = `
    <div style="max-width:760px;color:#111">
      <h1 style="margin:0 0 8px 0">Invoice</h1>
      <div style="display:flex;justify-content:space-between;margin-bottom:16px">
        <div>
          <div><strong>To:</strong></div>
          <div>${inv.customer}</div>
        </div>
        <div style="text-align:right">
          <div><strong>Date</strong></div>
          <div>${inv.date}</div>
        </div>
      </div>

      <table style="width:100%;border-collapse:collapse;margin-bottom:12px">
        <thead>
          <tr style="text-align:left;color:#333">
            <th style="padding:8px 0">Description</th>
            <th style="padding:8px 0;text-align:right">Qty</th>
            <th style="padding:8px 0;text-align:right">Price</th>
            <th style="padding:8px 0;text-align:right">Amount</th>
          </tr>
        </thead>
        <tbody>
          ${itemsHtml}
        </tbody>
      </table>

      <div style="display:flex;justify-content:flex-end;gap:24px;margin-top:12px">
        <div style="text-align:right">
          <div style="color:#666">Total</div>
          <div style="font-weight:700;font-size:18px">${formatCurrency(total)}</div>
        </div>
      </div>

      ${inv.notes ? `<div style="margin-top:18px;color:#444"><strong>Notes:</strong><div>${inv.notes}</div></div>` : ''}
    </div>
  `;

  document.body.appendChild(container);

  try {
    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    // Create PDF with A4 dimensions
    const pdf = new jsPDF({ unit: 'pt', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Calculate the image dimensions to fit the page width
    const imgProps = (pdf as any).getImageProperties ? pdf.getImageProperties(imgData) : { width: canvas.width, height: canvas.height };
    const imgWidth = pageWidth - 40; // margin
    const ratio = imgProps.width / imgWidth;
    const imgHeight = imgProps.height / ratio;

    pdf.addImage(imgData, 'PNG', 20, 20, imgWidth, imgHeight);
    pdf.save(`invoice-${inv.id}.pdf`);
  } catch (err) {
    console.error('PDF export failed', err);
    alert('Failed to export PDF');
  } finally {
    document.body.removeChild(container);
  }
}

export default exportInvoicePDF;
